import {HttpErrorResponse} from '@angular/common/http';

export const SESSION_EXPIRED_REASON = 'session_expired';

/**
 * Replaces the 401 of an API call the interceptor authenticated. By the time a
 * caller receives it the session is being ended and the user taken to the
 * login, so callers must not open a retry or error UI of their own.
 *
 * Only a 401 whose code is `session_expired` gets here (see the interceptor);
 * any other 401 reaches the caller as the HttpErrorResponse it is.
 */
export class SessionExpiredError extends Error {
  readonly status = 401;

  constructor(readonly cause: HttpErrorResponse, readonly code?: string) {
    super(SESSION_EXPIRED_REASON);
    this.name = 'SessionExpiredError';
  }
}

export const isSessionExpired = (error: unknown): error is SessionExpiredError => error instanceof SessionExpiredError;
